document.addEventListener("DOMContentLoaded", async ()=>{
  GT_SNST();
  LVPS_SP_SET_114();
  await mva_kntch_crtcnf_mncrt_chk();
}, false);

function LVPS_SP_SET_114(){
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("frm_lp_s");
  if(crt_size_base != null){
    sessionStorage.setItem("frm_lp_s_ssstr", crt_size_base);
  };
};

function GT_SNST(){
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("dandori");
  if(crt_size_base != null){
    sessionStorage.setItem("hnbt_lnd", "tunakura");
  };

  var hjn_hnbt_mark = CRTurl.searchParams.get("ski_bs");
  var ss_trhk_hjL = "006843,308836,479054,tklbn,107665,481477,315827,482120,441654,057727,427136,298309,332642,019006,360277,000125,426407,387985,113090,000288,364163,065129,299007,355487,128470,466860,381317,291658,490581,457507,045349,453296,366135,067251,300443,482706,389892,295754,363940,364834,426501,450636,361964,317244,076555,462134,320413,303283,459137,468424,442192,469000,483322,482357,486668,318158,462893,032635,453297,046612,417257,310545,462133,464152,333351,376659,481596,488890,407190,491859,491947,397793,464577,129739,405787,356506,356058,043144,333548,425938,125864,003413,492359,361162,419023,371795,460612,384338,310061,476774,417329,362332,133057,067413,299749,324341,296060,491266,380610,491263,442330,386297,418362,487503,388759,120908,358270,120695,127064,477542,454594,461997,466122,426141,468999,103487,305864,415906,444403,316720,417553,301116,123285,482692,305856,481721,288991,425138,123352,370248,406205,426284,421094,477426,304790,358097,470669,331217,318438,318839,481887,400751,333076,396463,490293,445451,380370,418450,442312,396874,369852,365716,416214,477229,363239,405353,385808,379874,460110,467676,487322,381740,112467,468648,317478,328415,406203,406313,366880,304427,120908,459944,468497,388769,459477,464220,080420,135972,478720,406666,300262,310575".split(',');
  if(ss_trhk_hjL.indexOf(hjn_hnbt_mark) > 0){
    sessionStorage.setItem("hnbt_lnd", hjn_hnbt_mark);
  };
  var ss_trhk_hjL_cmp = CRTurl.searchParams.get("ski_bs_cmp");
  if(ss_trhk_hjL_cmp != null){
    sessionStorage.setItem("hnbt_lnd", ss_trhk_hjL_cmp);
  };
  
  var tnkr_dt = sessionStorage.getItem("hnbt_lnd");
  if(tnkr_dt == "tunakura"){
    document.getElementsByTagName("header")[0].getElementsByClassName("header__logo-image")[0].setAttribute("src","https://cdn.shopify.com/s/files/1/0328/7439/7831/files/banner_2411_k_01.png?v=1731204281");
    document.getElementsByTagName("header")[0].getElementsByClassName("header__logo-link")[0].setAttribute("href","/");
  }else{
    document.getElementsByTagName("header")[0].getElementsByClassName("header__logo-image")[0].setAttribute("src","https://cdn.shopify.com/s/files/1/0632/1038/9752/files/00000.png?v=1730622057");
    document.getElementsByTagName("header")[0].getElementsByClassName("header__logo-link")[0].setAttribute("href","/");
  };
  prd_pg_sflp_bck();
};

function prd_pg_sflp_bck(){
  var Bul = new URL(window.location.href);
  if(Bul.searchParams.get("pssgf_pgbck") != null){
    if(Bul.searchParams.get("pssgf_pgbck").split("_")[0] == "pgv"){
      var bck_t_pp = document.createElement("a");
      bck_t_pp.setAttribute("href","/collections/ps_single_moving_lp_prdcllc_list_set#pslbck_" + Bul.searchParams.get("pssgf_pgbck").split("_")[1]);
      bck_t_pp.setAttribute("style","display: block;margin: 25px 8px 5px;width: fit-content;padding: 5px 15px;text-align:center;background-color: #898989;color: #fff;border-radius:8px;text-decoration:none;");
      bck_t_pp.textContent = "＜　前のページへ";
      document.querySelectorAll("#main .container.container--flush")[0].prepend(bck_t_pp);
    }else if(Bul.searchParams.get("pssgf_pgbck").split("_")[0] == "sstpgv"){
      var bck_t_pp = document.createElement("a");
      bck_t_pp.setAttribute("href","/collections/frm_sku_ssttyyk_lp#pslbck_" + Bul.searchParams.get("pssgf_pgbck").split("_")[1]);
      bck_t_pp.setAttribute("style","display: block;margin: 25px 8px 5px;width: fit-content;padding: 5px 15px;text-align:center;background-color: #898989;color: #fff;border-radius:8px;text-decoration:none;");
      bck_t_pp.textContent = "＜　前のページへ";
      console.log(1);
      document.querySelectorAll("#main .container.container--flush")[0].prepend(bck_t_pp);
    };
  };
};

async function mva_kntch_crtcnf_mncrt_chk(){
  var mva_kntch_crtcnf_ptp = window.location.pathname;
  var mtc_path_list = ["/cart","/collections/moving_accessory_kantan_chumon/mvngacce_827","/collections/moving_accessory_kantan_chumon/unnesship_827"];
  if(mtc_path_list.includes(mva_kntch_crtcnf_ptp) == false){
    if(document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_096")){
      document.querySelector("body").appendChild(document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_096"));
      document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_096").setAttribute("data-crtcnf_mncrt_dlg_dsp","true");
      document.querySelector('.mva_kntch_crtcnf_mncrt_dlg_section_096_body_button[data-crtcnf_mncrt_dlg_btn="true"]').addEventListener('click', ()=>{
        var mva_096_pglnk = document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_096").getAttribute("data-crtcnf_mncrt_dlg_mva_096_pglnk");
        document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_096_loading").setAttribute("data-crtcnf_load_096_dsp","true");
        window.location.href = mva_096_pglnk;
      });
      document.querySelector('.mva_kntch_crtcnf_mncrt_dlg_section_096_body_button[data-crtcnf_mncrt_dlg_btn="false"]').addEventListener('click', async ()=>{
        if(document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_section_096_body_error").getAttribute("data-crtcnf_mncrt_dlg_dlttry") == "0"){
          try {
              const response = await fetch(window.Shopify.routes.root + 'cart/clear.js',{method: 'POST',headers: {'Content-Type': 'application/json'}});
              if(!response.ok) {throw new Error('カートのクリアに失敗しました');}
              const cartData = await response.json();
              document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_096").setAttribute("data-crtcnf_mncrt_dlg_dsp","false");
              document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_096_loading").setAttribute("data-crtcnf_load_096_dsp","true");
              window.location.reload();
          }catch(error){
            console.error(error);
            document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_section_096_body_error").setAttribute("data-crtcnf_mncrt_dlg_dlttry","1");
            document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_section_096_body_error").setAttribute("style","display:block;");
          };
        }else{
          document.querySelector(".mva_kntch_crtcnf_mncrt_dlg_096").setAttribute("data-crtcnf_mncrt_dlg_dsp","false");
          window.location.href = "/cart"
        };
      });
    };
  };
};